export const formatMinutesToTimeLabel = (totalMinutes: number): string => {
    const minutesInDay = 24 * 60;
    const normalized =
        ((Math.round(totalMinutes) % minutesInDay) + minutesInDay) %
        minutesInDay;
    const hh = Math.floor(normalized / 60);
    const mm = normalized % 60;
    const h = String(hh).padStart(2, '0');
    const m = String(mm).padStart(2, '0');
    return `${h}:${m}`;
};
